<template>
    <button
        :is-disabled="isDisabled"
        :is-selected="isSelected"
        :class="[
            'border border-black py-2 text-[16px] whitespace-nowrap font-oceanside font-semibold',
            'focus:outline-none focus:ring-1 focus:ring-black focus:border-black',
            {
                'bg-black text-white': isSelected,
                'bg-white text-black': !isSelected,
                'text-red-error': hasErrorState,
            }
        ]"
    >
        <slot />
    </button>
</template>

<script>
    export default {
        props: {
            isDisabled: {
                type: Boolean,
                default: false,
            },
            isSelected: {
                type: Boolean,
                default: false,
            },
            hasErrorState: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>
